export default "__VITE_ASSET__C_bN4dd1__"